import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateAciModal } from "../../redux/actions/cartActions";

function ReplaceCartItems(props) {
  const { rciModal, setRciModal, addItemToCart } = props;
  const dispatch = useDispatch();

  const yesHandler = () => {
    addItemToCart();
    setRciModal(false);
  };

  const noHandler = () => {
    setRciModal(false);
    dispatch(updateAciModal(false));
  };

  return (
    <Modal
      show={rciModal}
      onHide={() => setRciModal(false)}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Replace cart item?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Your cart contains dishes from Other Restaurant. Do you want to discard
        the selection and add dishes from this Restaurant?
      </Modal.Body>
      <Modal.Footer>
        <div className="text-end">
          <button className="cusbtn" onClick={yesHandler}>
            Yes
          </button>

        </div>

        <div className="text-end">
          <button className="cusbtn" onClick={noHandler}>
            No
          </button>
        </div>

      </Modal.Footer>
    </Modal>
  );
}
export default ReplaceCartItems;
